import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTextField from '@material-ui/core/TextField';
import MuiCheckbox from '@material-ui/core/Checkbox';

const styles = theme => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

const Row = props => {
  const { classes, row, editing, onInputChange } = props;
  const disabledInputs = !editing;

  return (
    <MuiTableRow className={classes.root}>
      <MuiTableCell component="th" scope="row">
        {row.id}
      </MuiTableCell>
      <MuiTableCell>{row.identifier}</MuiTableCell>
      <MuiTableCell style={{ width: '30%' }}>
        <MuiTextField disabled={disabledInputs} name="name" value={row.name} onChange={onInputChange} />
      </MuiTableCell>
      <MuiTableCell>
        <MuiCheckbox
          name="sound_recording_support"
          disabled={disabledInputs}
          onChange={onInputChange}
          checked={row.sound_recording_support}
        />
      </MuiTableCell>
      <MuiTableCell>
        <MuiCheckbox
          name="video_support"
          disabled={disabledInputs}
          onChange={onInputChange}
          checked={row.video_support}
        />
      </MuiTableCell>
      <MuiTableCell>
        <MuiCheckbox
          name="system_admin_only"
          disabled={disabledInputs}
          onChange={onInputChange}
          checked={row.system_admin_only}
        />
      </MuiTableCell>
      <MuiTableCell>
        <MuiCheckbox
          name="supports_ddex_timed_release"
          disabled={disabledInputs}
          onChange={onInputChange}
          checked={row.supports_ddex_timed_release}
        />
      </MuiTableCell>
    </MuiTableRow>
  );
};

export default withStyles(styles)(Row);
